export default "__VITE_ASSET__CmQ7LuG1__"